// TO DO update with system rejection reasons
export const TENDER_APPLICATION_SYSTEM_REJECTION_REASONS = [
  "OTHER",
  "TENDER_ENDED",
  "DEADLINE_EXPIRED",
] as const;
